<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar :background-color="sidebarBackground">
      <template #links>
        <div class="sidebar-drawer-shell">
          <div class="sidebar-scroll-area">
            <ul class="sidebar-nav">
              <li
                class="nav-link home-link mini-list-item"
                @click="openHomePage"
              >
                <span
                  class="sidebar-link-icon icon-mini"
                  v-if="$sidebar.isMinimized"
                >
                  <img class="nav-icon" :src="`/img/icons/gfb-logo-mini.svg`" />
                  <span class="tooltipText">Home</span>
                </span>
                <span class="sidebar-link-icon icon-large" v-else>
                  <img
                    class="nav-icon"
                    :src="`/img/icons/gfb-logo-large.svg`"
                  />
                </span>
              </li>

              <li
                v-for="item in sidebarItems"
                :key="item.title"
                class="nav-link mini-list-item"
                :class="{
                  'current-route':
                    $route.path === item.to ||
                    (Array.isArray(item.children) &&
                      item.children.includes($route.path)),
                }"
                @click="$router.push(item.to)"
              >
                <span class="sidebar-link-icon">
                  <component size="24" v-bind:is="item.icon"></component>
                  <div
                    v-if="
                      item.title == 'Find employees' &&
                      isNewApplicants &&
                      $sidebar.isMinimized
                    "
                    class="alert-badge"
                  >
                    <AlertBadge />
                  </div>
                  <div
                    v-if="
                      item.title == 'Trade Partners' &&
                      hasProjectNotification &&
                      $sidebar.isMinimized
                    "
                    class="alert-badge"
                  >
                    <AlertBadge />
                  </div>
                  <div
                    v-if="
                      item.title == 'Messages' &&
                      unreadCount > 0 &&
                      $sidebar.isMinimized
                    "
                    class="alert-badge"
                  >
                    <span
                      v-if="
                        item.title === 'Messages' && unreadCount > 0 && mini
                      "
                      class="unread-count-badge unread-count-badge--mini"
                      >{{ unreadCount > 99 ? "99+" : unreadCount }}
                    </span>
                    <AlertBadge />
                  </div>
                  <span class="tooltipText" v-if="$sidebar.isMinimized">
                    {{ item.tooltip || item.title }}
                  </span>
                </span>
                <span v-if="!$sidebar.isMinimized" class="sidebar-link-text">
                  {{ item.title }}
                  <span
                    v-if="item.title === 'Messages' && unreadCount > 0"
                    class="unread-count-badge"
                    >{{
                      unreadCount > 99 ? "99+ unread" : unreadCount + " unread"
                    }}</span
                  >
                </span>
                <span
                  v-if="
                    ((item.title == 'Find employees' ||
                      item.title == 'Find Jobs') &&
                      hasJobBriefingNotification) ||
                    (item.title == 'Trade Partners' &&
                      hasProjectNotification) ||
                    (item.title == 'Find employees' && isNewApplicants)
                  "
                  class="nav-dot"
                >
                  <svg
                    width="13"
                    height="12"
                    viewBox="0 0 13 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle
                      cx="6.97656"
                      cy="6"
                      r="5"
                      fill="#FA0000"
                      stroke="white"
                      stroke-width="2"
                    />
                  </svg>
                </span>
              </li>

              <li class="nav-separator"><hr /></li>

              <li class="nav-link mini-list-item" @click="handleSupportModal()">
                <span class="sidebar-link-icon">
                  <img class="nav-icon" :src="`/img/icons/Support 1 1.svg`" />
                  <span class="tooltipText" v-if="$sidebar.isMinimized"
                    >Support</span
                  >
                </span>
                <span v-if="!$sidebar.isMinimized" class="sidebar-link-text"
                  >Support</span
                >
              </li>

              <li
                v-if="profileType == 'company'"
                class="mini-list-group-item nav-link nav-group"
                :class="{
                  'current-route':
                    $route.path == '/toolbox/settings' ||
                    $route.path == '/toolbox/billing' ||
                    $route.path == '/toolbox/users-management',
                }"
              >
                <button
                  class="nav-group-toggle"
                  type="button"
                  @click="companyItems.active = !companyItems.active"
                >
                  <span class="sidebar-link-icon">
                    <component
                      size="24"
                      v-bind:is="companyItems.icon"
                    ></component>
                    <span class="tooltipText" v-if="$sidebar.isMinimized">{{
                      companyItems.title
                    }}</span>
                  </span>
                  <span v-if="!$sidebar.isMinimized" class="sidebar-link-text">
                    <span
                      class="nav-group-title-row flex justify-content-between"
                    >
                      <span>{{ companyItems.title }}</span>
                      <PhCaretDown
                        class="nav-group-chevron"
                        :class="{ open: companyItems.active }"
                        size="16"
                        weight="bold"
                      />
                    </span>
                    <small>{{ companyItems.companyName }}</small>
                  </span>
                </button>

                <ul v-show="companyItems.active" class="nav-group-items">
                  <li
                    v-for="child in companyItems.items"
                    :key="child.title"
                    class="nav-link mini-list-item"
                    :class="{ 'current-route': $route.path == child.to }"
                    @click="$router.push(child.to)"
                  >
                    <span class="sidebar-link-icon">
                      <component size="24" v-bind:is="child.icon"></component>
                      <span class="tooltipText" v-if="$sidebar.isMinimized">{{
                        child.title
                      }}</span>
                    </span>
                    <span
                      v-if="!$sidebar.isMinimized"
                      class="sidebar-link-text"
                      >{{ child.title }}</span
                    >
                  </li>
                </ul>
              </li>

              <li
                v-if="profileType == 'jobSeeker'"
                class="mini-list-group-item nav-link nav-group"
                :class="{
                  'current-route':
                    $route.path == '/toolbox/settings' ||
                    $route.path == '/toolbox/billing' ||
                    $route.path == '/toolbox/users-management',
                }"
              >
                <button
                  class="nav-group-toggle"
                  type="button"
                  @click="jobSeekerItems.active = !jobSeekerItems.active"
                >
                  <span class="sidebar-link-icon">
                    <component
                      size="24"
                      v-bind:is="jobSeekerItems.icon"
                    ></component>
                    <span class="tooltipText" v-if="$sidebar.isMinimized">{{
                      jobSeekerItems.title
                    }}</span>
                  </span>
                  <span v-if="!$sidebar.isMinimized" class="sidebar-link-text">
                    <span class="nav-group-title-row">
                      <span>{{ jobSeekerItems.title }}</span>
                      <PhCaretDown
                        class="nav-group-chevron"
                        :class="{ open: jobSeekerItems.active }"
                        size="14"
                      />
                    </span>
                    <small>Job Seeker</small>
                  </span>
                </button>

                <ul v-show="jobSeekerItems.active" class="nav-group-items">
                  <li
                    v-for="child in jobSeekerItems.items"
                    :key="child.title"
                    class="nav-link mini-list-item"
                    :class="{ 'current-route': $route.path == child.to }"
                    @click="$router.push(child.to)"
                  >
                    <span class="sidebar-link-icon">
                      <component size="24" v-bind:is="child.icon"></component>
                      <span class="tooltipText" v-if="$sidebar.isMinimized">{{
                        child.title
                      }}</span>
                    </span>
                    <span
                      v-if="!$sidebar.isMinimized"
                      class="sidebar-link-text"
                      >{{ child.title }}</span
                    >
                  </li>
                </ul>
              </li>

              <li
                title="Logout"
                class="nav-link mini-list-item"
                @click="showLogoutModal()"
              >
                <span class="sidebar-link-icon">
                  <PhSignOut size="24" />
                  <span class="tooltipText" v-if="$sidebar.isMinimized"
                    >Logout</span
                  >
                </span>
                <span v-if="!$sidebar.isMinimized" class="sidebar-link-text"
                  >Logout</span
                >
              </li>
            </ul>
          </div>
          <button
            type="button"
            @click.stop="toggleMini"
            :class="['toggle-nav', { open: $sidebar.isMinimized }]"
            aria-label="Toggle sidebar"
          ></button>
        </div>
      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <navbar
        :sidebarItems="sidebarItems"
        :isNewApplicants="isNewApplicants"
      ></navbar>
      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
    </div>
    <support-modal v-on:send-support-request="sendSupportRequest">
    </support-modal>
    <default-modal
      description="Do you want to logout?"
      title="Logout"
      @onConfirm="handleLogout"
      id="logout-modal"
      :showCancel="true"
      :btnClasses="['delete-btn']"
    />
  </div>
</template>
<script>
import Navbar from "./Navbar.vue"
import { FadeTransition } from "vue2-transitions"
import SupportModal from "@/components/Modals/SupportModal"
import {
  PhUser,
  PhHandshake,
  PhHouse,
  PhUsers,
  PhBriefcase,
  PhMagnifyingGlass,
  PhSignOut,
  PhGear,
  PhCurrencyDollar,
  PhUserCircle,
  PhKey,
  PhEnvelope,
  PhCaretDown,
} from "@phosphor-icons/vue"
import AlertBadge from "@/components/AlertBadge.vue"
import { mapState } from "vuex"
import moment from "moment"

export default {
  components: {
    Navbar,
    FadeTransition,
    SupportModal,
    PhUser,
    PhHandshake,
    PhUsers,
    PhHouse,
    PhBriefcase,
    PhMagnifyingGlass,
    PhSignOut,
    PhGear,
    PhCurrencyDollar,
    PhUserCircle,
    AlertBadge,
    PhKey,
    PhEnvelope,
    PhCaretDown,
  },
  data() {
    const userProfile = this.$store.state.userProfile
    const profileType = userProfile?.jobSeeker ? "jobSeeker" : "company"
    const userdetails = this.$store.state.user
    const projects = this.$store.state.projects?.list || []

    const companyItems = {
      icon: "PhUserCircle",
      active: false,
      items: [
        { title: "Settings", icon: "PhGear", to: "/toolbox/settings" },
        { title: "Billing", icon: "PhCurrencyDollar", to: "/toolbox/billing" },
        {
          title: "User Management",
          icon: "PhUsers",
          to: "/toolbox/users-management",
        },
        { title: "Credentials", icon: "PhKey", to: "/toolbox/change-password" },
      ],
      title: [userdetails.firstName, userdetails.lastName]
        .filter(Boolean)
        .join(" "),
      companyName: userProfile.name,
    }
    const jobSeekerItems = {
      icon: "PhUserCircle",
      active: false,
      items: [
        { title: "Settings", icon: "PhGear", to: "/toolbox/settings" },
        { title: "Credentials", icon: "PhKey", to: "/toolbox/change-password" },
      ],
      title: [userProfile.name, userProfile.lastName].filter(Boolean).join(" "),
    }
    const sidebarItems = [
      {
        title: "Dashboard",
        to: "/dashboard",
        icon: "PhHouse",
      },
      {
        title: "Messages",
        to: "/messages",
        icon: "PhEnvelope",
      },
      ...(profileType === "jobSeeker"
        ? [
            {
              title: "Profile",
              to: "/toolbox/update-profile",
              icon: "PhUser",
            },
            {
              title: "Find Jobs",
              to: "/jobs/search",
              icon: "PhMagnifyingGlass",
            },
            {
              title: "My Jobs",
              to: "/my-jobs/activities",
              icon: "PhBriefcase",
              children: ["/my-jobs/activities", "/my-jobs/saved"],
            },
          ]
        : []),
      ...(profileType === "company"
        ? [
            {
              title: "Company Profile",
              to: "/toolbox/update-profile",
              icon: "PhUser",
            },
            {
              title: "Trade Partners",
              to: "/trade-partners/projects",
              icon: "PhHandshake",
              children: [
                "/trade-partners/projects",
                "/trade-partners/search",
                "/trade-partners/search-projects",
              ],
            },
            {
              title: "Find employees",
              to: "/employees/jobs",
              icon: "PhUsers",
              children: ["/employees/jobs", "/employees/company-matches"],
            },
          ]
        : []),
    ]
    return {
      profileType,
      sidebarItems,
      companyItems,
      jobSeekerItems,
      sidebarBackground: "vue", //vue|blue|orange|green|red|primary,
      drawer: true,
      mini: true,
      hasJobBriefingNotification:
        this.$store.state.userProfile.type == "jobSeeker" &&
        this.$store.state.userProfile.profilesRequested.findIndex(
          (x) =>
            x.type == "job" && x.profile != this.$store.state.userProfile._id
        ) > -1,
      hasJobApplicationNotification:
        this.$store.state.userProfile.type == "provider" &&
        this.$store.state.userProfile.profilesRequested.findIndex(
          (x) => x.type == "job-application"
        ) > -1,
      isNewApplicants: false,
      projects,
    }
  },
  computed: {
    ...mapState({
      jobs: ({ jobs }) => JSON.parse(JSON.stringify(jobs.list)),
    }),
    unreadCount() {
      return this.$store.state.messaging.unreadCount
    },
    hasProjectNotification() {
      const projects = this.$store.state.projects?.list || []
      return projects.some((project) => this.shouldShowAlert(project))
    },
    categories() {
      return this.$store.state.categories
    },
  },
  mounted() {
    this.getJobs()
    this.getProjects()
    if (!this.$store.state.categories || !this.$store.state.categories.length) {
      this.$store.dispatch("fetchCategories")
    }
    this.$store.dispatch("messaging/fetchUnreadCount")
    this._unreadCountInterval = setInterval(() => {
      this.$store.dispatch("messaging/fetchUnreadCount")
    }, 30000)
  },
  beforeUnmount() {
    clearInterval(this._unreadCountInterval)
  },
  methods: {
    openHomePage() {
      window.open("https://www.gofindbuild.com", "_blank", "noopener")
    },
    toggleMini() {
      this.$sidebar.toggleMinimize()
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false)
      }
    },
    async getProjects() {
      await this.$store.dispatch("projects/dispatchFetchProjects")
      this.projects = this.$store.state.projects.list
    },
    async getJobs() {
      await this.$store.dispatch("jobs/dispatchFetchJobs")

      for (let job of this.jobs) {
        job.lastViewAt = job.lastViewAt ? new Date(job.lastViewAt) : null
        this.hasJobAlerts(job)
        job.postDate = moment(job.createdAt).format("MMM DD, YYYY")
      }
    },
    async hasJobAlerts(job) {
      let requests = this.$store.state.userProfile.profilesGranted
      let j = job
      j.applicants = []
      for (let r of requests) {
        if (r.type == "job-application" && r.job == j._id && r.profile) {
          if (j.applicants) {
            j.applicants.push(r)
          } else {
            j.applicants = [r]
          }
        }
      }
      requests = this.$store.state.userProfile.profilesRequested
      for (let r of requests) {
        if (r.type == "job-application" && r.job == j._id && r.profile) {
          if (j.applicants) {
            j.applicants.push(r)
          } else {
            j.applicants = [r]
          }
        }
      }

      //remove duplicates
      if (j.applicants) {
        j.applicants = j.applicants.filter(
          (v, i, a) => a.findIndex((t) => t.profile == v.profile) === i
        )
      }

      if (j.lastViewAt) {
        j.hasNewApplicants = j.applicants.some((a) => {
          const applicantDate = new Date(a.date).getTime()
          const lastViewDate = new Date(j.lastViewAt).getTime()
          return applicantDate > lastViewDate
        })
      } else {
        j.hasNewApplicants = false
      }

      // Check if any job has new applicants and store the result in localStorage
      const hasAnyNewApplicants = this.jobs.some((job) => job.hasNewApplicants)

      this.isNewApplicants = hasAnyNewApplicants

      job = j
    },
    shouldShowAlert(project) {
      const notifications = (
        this.$store.state.userProfile.profilesRequested || []
      ).filter((n) => n.project === project._id)

      if (!notifications.length) return false

      if (!project.lastViewAt) return true

      const lastViewedAt = new Date(project.lastViewAt)
      return notifications.some((n) => new Date(n.date) > lastViewedAt)
    },
    handleSupportModal() {
      this.$bvModal.show("support-modal")
    },
    async sendSupportRequest(data) {
      try {
        const profile = this.$store.state.userProfile
        const { id, type } = profile
        await this.$store.dispatch(
          `api/${type == "jobSeeker" ? "sendSupport" : "sendCompanySupport"}`,
          {
            data,
            profileId: id,
          }
        )
        this.$bvModal.hide("support-modal")
        this.$toast.success("Support request sent!")
      } catch (e) {
        this.$toast.error("Error sending support request")
      }
    },
    showLogoutModal() {
      this.$bvModal.show("logout-modal")
    },
    async handleLogout() {
      try {
        await this.$router.replace("/logout")
      } catch (error) {
        this.showErrorMessage(error, "We couldn't revoke your credentials.")
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.path !== from.path) {
        this.getJobs()
      }
      this.companyItems.active = false
      this.jobSeekerItems.active = false
    },
  },
}
</script>
<style lang="scss">
.alert-badge {
  position: absolute;
  left: 30px;
  bottom: 26px;
}
.wrapper {
  display: flex;
  background: #f6f7f9;
}

.mini-list-item,
.mini-list-group-item {
  position: relative !important;
  padding: 8px 12px !important;

  &.current-route {
    background: var(--gfb-blue-brand-70050-opacity, rgba(0, 82, 124, 0.5));
    border-radius: 8px !important;
  }
}

.mini-list-item .tooltipText,
.mini-list-group-item .tooltipText {
  visibility: hidden;
  width: max-content !important;
  height: auto !important;
  background-color: var(--Gray-800, #3a4252);
  color: #fff;
  text-align: center;
  border-radius: 4px;
  padding: 5px;
  position: absolute;
  z-index: 999999;
  top: 50%;
  left: calc(100% + 12px);
  transform: translateY(-50%);
  font-size: 14px;
  font-weight: 400;
}

.mini-list-group-item .v-list-group__header .tooltipText {
  left: 150%;
}

.mini-list-item .tooltipText::after,
.mini-list-group-item .tooltipText::after {
  content: "";
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent var(--Gray-800, #3a4252) transparent transparent;
}

.mini-list-item:hover .tooltipText,
.mini-list-group-item:hover .tooltipText {
  visibility: visible;
}

.nav-list {
  margin-top: 25px !important;
  top: 75px;
}

.sidebar-nav {
  list-style: none;
  margin: 0;
  padding: 0;
}

.sidebar-nav > li {
  display: flex;
  align-items: center;
}

.sidebar-nav > li.home-link {
  margin-bottom: 35px;
}

body.sidebar-mini #sidenav-main {
  width: 88px !important;
  max-width: 88px !important;
}

body.sidebar-mini #sidenav-main .navbar-collapse,
body.sidebar-mini #sidenav-main .navbar-nav,
body.sidebar-mini #sidenav-main .sidebar-drawer-shell,
body.sidebar-mini #sidenav-main .sidebar-scroll-area {
  width: 100%;
}

body.sidebar-mini #sidenav-main .sidebar-scroll-area {
  overflow: visible;
}

body.sidebar-mini #sidenav-main .nav-link,
body.sidebar-mini #sidenav-main .nav-group-toggle {
  justify-content: center !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}

body.sidebar-mini #sidenav-main .sidebar-link-icon {
  margin-right: 0 !important;
}

body.sidebar-mini #sidenav-main .home-link {
  min-height: 56px;
}

body.sidebar-mini #sidenav-main .nav-group-items {
  padding-left: 0 !important;
}

.sidebar-link-icon {
  display: inline-flex;
  align-items: center;
  position: relative;
  min-width: 24px;
  margin-right: 10px;
  min-height: 40px;
}

.sidebar-link-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  padding: 8px;
}

.nav-group-title-row {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.nav-group-chevron {
  transition: transform 0.2s ease;
}

.nav-group-chevron.open {
  transform: rotate(180deg);
}

.sidebar-link-text small {
  opacity: 0.8;
  font-size: 12px;
  line-height: 1.2;
}

.sidebar-link-button,
.nav-group-toggle {
  width: 100%;
  border: 0;
  background: transparent;
  color: inherit;
  text-align: left;
  display: flex;
  align-items: center;
  padding: 0;
}

.nav-group {
  flex-direction: column !important;
  align-items: stretch !important;
}

.nav-group-items {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-group-items .mini-list-item {
  padding-left: 2rem !important;
}

.nav-separator {
  hr {
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 0px;
    flex: 1 1 0px;
    max-width: 100%;
    height: 0;
    max-height: 0;
    border: solid;
    border-width: thin 0 0;
    -webkit-transition: inherit;
    transition: inherit;
    color: #fff;
    border-color: #525e77 !important;
    margin: 8px 10px !important;
  }
}

@media (max-width: 767.98px) {
  #sidenav-main {
    display: none;
  }
}
</style>
